import React from 'react';

import './Footer.scss';


export default class Footer extends React.Component {
    render() {
        return (
            <div className="Footer">

                <p>© 2013-2026 WSCproject v.0.8.0 </p>

            </div>
        )
    }
}